import request from '../Functions/ajax/request'

export default async function DemandeLoader ({ params })
{
	return { page: getPage({ params }) };
}

async function getPage ({ params })
{
	if (!params.demande_id) throw { code: 404, throw_up:true };

	try {
		var { demande } = await request('/comptes/get-demande')
		.config({ })
		.post({ id: params.demande_id });

	} catch (e) {
		console.error(e);
	}

	return demande;
}